import styled from "styled-components";

export const FellingClasses = [ 
    { label: "K", value: "K" }, 
    { label: "R", value: "R" },
    { label: "G1", value: "G1" },
    { label: "G2", value: "G2" },
    { label: "S1", value: "S1" },
    { label: "S2", value: "S2" },
    // FBA
    { label: "S3", value: "S3"},
    { label: "K1", value: "K1"},
    { label: "K2", value: "K2"},
    { label: "R1", value: "R1"},
    { label: "R2", value: "R2"},
   
    {label: "IA",  value:"IA"},
]

export const FellingClassesLegend = {
    S1: {text: 'Yngre slutavverkningsbar skog', color: '#c9c9c9'},
    S2: {text: 'Mogen avverkningsbar skog som bör slutavverkas', color: '#696969'},
    G1: {text: 'Yngre gallringsskog', color: '#8af389'},
    G2: {text: 'Äldre gallringsskog som uppnått lägsta ålder för slutavverkning', color: '#10950f'},
    R: {text: 'Röjningsskog', color: '#95d0ea'},
    K: {text: 'Kalmark före föryngringsåtgärder', color: '#ff8080'},
    // FBA files have this
    S3: {text: 'Mogen avverkningsbar skog som bör slutavverkas', color: '#696969'}, //S3 made similar to S2 but can be changed
    K1: {text: 'Kalmark före föryngringsåtgärder', color: '#ff8080'}, //K1 and K2 similar to K
    K2: {text: 'Kalmark före föryngringsåtgärder', color: '#ff8080'},
    R1: {text: 'Röjningsskog', color: '#95d0ea'}, //R1 and R2 same to R
    R2: {text: 'Röjningsskog', color: '#95d0ea'},
    NS: {text: "Naturhänsyn", color: '#ffff00'},

    IA: {text: 'Ingen åtgärd', color: '#bb0000'}
}

export const SiValues = Array.from({ length: 33 }, (_, i) => i+14)


export const beetleRiskColors = {
    "Liten risk": "#008000",
    "Medel risk": "#FFFF00",
    "Hög risk": "#FF0000",
    "Ingen prognos": "#808080"
}

export const PropselectorContainer = styled.div`
    width: 90vw;
    max-width: 450px;
    transform: translate(-50%, 0);
    left: 50%;
    top: 10px;
`

export const ToolboxContainer = styled.div`
    width: 40px;
    right: 10px;
    top: 90px;
    @media (min-width: 992px) {
        top: 10px;
    }
`

export const MapTools = styled.div`
    display: none;
    max-width: 100vw;
    left: 50%;
    transform: translate(-50%, 0);

    &.show {
        display: block;
        bottom: 80px;
        @media (min-width: 576px) {
            bottom: 0;
        }
    }

    &.layers-open {
        left: 0;
        right: 0;
        bottom: 0;
        transform: none;
        border-radius: 0;
        margin: 0 auto;
        width: auto;
        overflow: auto;

        @media (max-width: 575px) {
            top: 0;
            width: 100%;
            height: 100dvh;
            max-height: 100dvh;
            max-width: 100dvw;
        }
    }
    
    @media (min-width: 576px) {
        left: calc(50% + 135px);
        max-width: 600px;
    }

    &.map-tools-immersive:not(.layers-open) {
        left: 50% !important;
    }

    &.map-tools-immersive.layers-open {
        @media (max-width: 575px) {
            height: 100%;
            max-height: 100%;
        }
    }
`

export const setUserLocation = (map) => {  
    if (navigator.geolocation) {
        map.locate({ setView: true, maxZoom: 16 });
  
        map.on('locationfound', (e) => {    
            // Check if latitude and longitude are valid numbers
            if (!isNaN(e.latitude) && !isNaN(e.longitude)) {
                L.marker([e.latitude, e.longitude]).addTo(map);
            } else {
                alert('Ogiltiga latitud- eller longitudvärden');
            }
        });
  
        map.on('locationerror', (e) => alert("Geolokaliseringsfel: " + e.message));
    } else {
        alert("Geolokalisering stöds inte i den här webbläsaren!");
    }
};

export const coptureLayerList = (props, flat=true) => {
    if(flat) {
        return props.filter(itm => itm?.data?.extra_layers)?.flatMap(itm => {
            return itm.data.extra_layers.map(layer => {
                return {obj: layer, ref: itm.ref, designation: itm.designation}
            }) 
        })
    } else {
        return props.filter(itm => itm?.data?.extra_layers)?.map(itm => {
            return {layers: itm.data.extra_layers, ref: itm.ref, designation: itm.designation}
        })
    }
}

export const sortProps = (list) => {
    return list.sort((a, b) => {
        // Prioritize active items
        if (a.active !== b.active) {
            return b.active - a.active;
        }
    
        // Prioritize status
        const statusOrder = ['data', 'running', 'warning', 'broken'];
        const statusA = statusOrder.indexOf(a.status);
        const statusB = statusOrder.indexOf(b.status);
        if (statusA !== statusB) {
            return statusA - statusB; 
        }
    
        // Within the same status, prioritize unlocked items
        if (a.locked !== b.locked) {
            return a.locked - b.locked;
        }
    
        // If all else fails, default to alphabetical order by name
        return a.designation.localeCompare(b.designation);
    })
}
